import React, { useState } from "react";
import { Collapse } from "react-bootstrap";

function RBQMCollapseSidebar({ handleAddNewTab, checkActiveTab }) {
  const [openSites, setOpenSites] = useState(false);
  return (
    <>
      <div className="link__tab">
        <div
          onClick={() => setOpenSites(!openSites)}
          aria-expanded={openSites}
          className={"text-start h-auto tab_url w-100"}
          style={{ background: "#ccd6dd" }}
          title="RBQM (Risk based query management)"
        >
          <div className="hstack justify-content-between">
            <div>
              <i className={"me-2 ps-0 fa-solid fa-folder"}></i>
            </div>
          </div>
        </div>
      </div>

      <Collapse in={true}>
        <div>
          <span
            className={`CP ps-3 small linkClass py-2 ${
              checkActiveTab("riskCategoryDataId") && "selectedMenu"
            }`}
            onClick={() => {
              handleAddNewTab(
                `Risk Category`,
                "fa-solid fa-shield",
                "riskCategoryDataId"
              );
            }}
            title=" Risk Category"
          >
            <i className={"fa-solid fa-shield"}></i>
          </span>
          <span
            className={`CP ps-3 small linkClass py-2 ${
              checkActiveTab("riskAreaDataId") && "selectedMenu"
            }`}
            onClick={() => {
              handleAddNewTab(
                `Risk Area`,
                "fa-solid fa-shield",
                "riskAreaDataId"
              );
            }}
            title=" Risk Area"
          >
            <i className={"fa-solid fa-shield"}></i>
          </span>
          <span
            className={`CP ps-3 small linkClass py-2 ${
              checkActiveTab("riskManagementDataId") && "selectedMenu"
            }`}
            onClick={() => {
              handleAddNewTab(
                `Risk Management`,
                "fa-solid fa-shield",
                "riskManagementDataId"
              );
            }}
            title=" Risk Management"
          >
            <i className={"fa-solid fa-shield"}></i>
          </span>
        </div>
      </Collapse>
    </>
  );
}

export default RBQMCollapseSidebar;
